import { ActionIcon } from "@/dmr/common/SvgIcons";
import useClickOutside from "@/hooks/useClickOutSide";
import { useState } from "react";

type ButtonWithActionsProps = {
  dropdownClassName?: string;
  listClassName?: string;
  btnClassName?: string;
  text?: string;
  childOptions: { name: string; label: string; onClick: () => void; className?: string }[];
};

const ButtonWithActions: React.FC<ButtonWithActionsProps> = ({ childOptions, dropdownClassName = "", listClassName = "", btnClassName = "" }) => {
  const [showActions, setShowActions] = useState(false);
  const actionsRef = useClickOutside(() => setShowActions(false));

  const handleOnClick = (e: any) => {
    e.preventDefault();
    setShowActions((pre) => !pre);
  };

  return (
    <div className="flex items-center h-10 relative z-50 hover:cursor-pointer" ref={actionsRef}>
      <button className={`px-3 flex items-center bg-white text-white  h-full rounded-r-lg border-l ${btnClassName}`} onClick={handleOnClick}>
        {ActionIcon}
      </button>
      {/* Dropdown Menu */}
      {showActions && (
        <div className={`absolute p-1 top-full right-0 w-40 bg-white border border-gray-200 shadow-lg rounded-md z-[100] ${dropdownClassName}`}>
          {childOptions.map((option) => (
            <div
              key={option.name}
              className={`px-2 py-2 hover:bg-primaryOpacity-10 hover:text-text-primary cursor-pointer text-sm text-gray-700 ${listClassName}`}
              onClick={() => {
                setShowActions(false);
                option.onClick();
              }}
            >
              <span className="whitespace-nowrap"> {option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ButtonWithActions;
